import { render } from "./error-details.vue?vue&type=template&id=98e276a0&ts=true"
import script from "./error-details.ts?vue&type=script&lang=ts&external"
export * from "./error-details.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__